import { defineAsyncComponent } from 'vue';

const TextField = defineAsyncComponent(() => import('@maison/components/form/fields/TextField.vue'));
const SelectField = defineAsyncComponent(() => import('@maison/components/form/fields/SelectField.vue'));
const RadioListField = defineAsyncComponent(() => import('@maison/components/form/fields/RadioListField.vue'));
const PhoneField = defineAsyncComponent(() => import('@maison/components/form/fields/PhoneField.vue'));
const TextareaField = defineAsyncComponent(() => import('@maison/components/form/fields/TextareaField.vue'));
const CheckboxField = defineAsyncComponent(() => import('@maison/components/form/fields/CheckboxField.vue'));
const PasswordField = defineAsyncComponent(() => import('@maison/components/form/fields/PasswordField.vue'));
const FileField = defineAsyncComponent(() => import('@maison/components/form/fields/FileField.vue'));

export function getFieldComponentForType(type) {
  switch (type) {
    case 'checkbox':
      return CheckboxField;
    case 'file':
      return FileField;
    case 'password':
      return PasswordField;
    case 'phone':
      return PhoneField;
    case 'radio':
      return RadioListField;
    case 'select':
      return SelectField;
    case 'textarea':
      return TextareaField;
    default:
      return TextField;
  }
}
